// src/app/hooks/drain_pan/queries.ts
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  useGetDrainPanParamsQuery,
  useLazyGetDrainPanQuery,
} from '../../services';
import { setDrainPan, setDrainPanParams } from '../../slices';

export const useGetDrainPanMainData = (id: number) => {
  const { isLoading: drainPanLoading } = useGetDrainPan(id);
  const { isLoading } = useGetDrainPanParams();

  return {
    isLoading: isLoading || drainPanLoading,
  };
};

export const useGetDrainPan = (id: number, fetch = true) => {
  const dispatch = useDispatch();
  const [getDrainPan, { data: drain_pan, isLoading }] =
    useLazyGetDrainPanQuery();

  useEffect(() => {
    if (fetch && id) {
      getDrainPan(id);
    }
  }, [id]);

  useEffect(() => {
    if (drain_pan) dispatch(setDrainPan(drain_pan));
  }, [drain_pan]);

  return {
    drain_pan,
    isLoading,
    getDrainPan,
  };
};

export const useGetDrainPanParams = () => {
  const dispatch = useDispatch();

  const { data: params, isLoading, refetch } = useGetDrainPanParamsQuery();

  useEffect(() => {
    if (params) {
      dispatch(setDrainPanParams(params.drain_pan));
    }
  }, [params]);

  return { isLoading, params, get: refetch };
};